
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import DeviceListHeader from './DeviceListHeader';
import DeviceTableRow from './DeviceTableRow';
import { useDeviceList } from './useDeviceList';

interface RegisteredDevicesListProps {
  onRegisterNew: () => void;
}

const RegisteredDevicesList: React.FC<RegisteredDevicesListProps> = ({ onRegisterNew }) => {
  const {
    filteredDevices,
    searchQuery,
    editingDevice,
    editValues,
    handleSearch,
    handleEditDevice,
    handleSaveEdit,
    handleCancelEdit,
    handleDeleteDevice,
    handleToggleStatus,
    handleInputChange,
    formatDate
  } = useDeviceList();

  return (
    <div className="space-y-4">
      <DeviceListHeader 
        searchQuery={searchQuery}
        onSearchChange={handleSearch}
        onRegisterNew={onRegisterNew}
      />

      <div className="border rounded-md">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Device ID</TableHead>
              <TableHead>Device Name</TableHead>
              <TableHead>Department</TableHead>
              <TableHead>Category</TableHead>
              <TableHead>Serial Number</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Last Active</TableHead>
              <TableHead className="w-[100px]">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredDevices.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} className="text-center py-4 text-muted-foreground">
                  No devices found matching your search criteria
                </TableCell>
              </TableRow>
            ) : (
              filteredDevices.map((device) => (
                <DeviceTableRow
                  key={device.id}
                  device={device}
                  editingDevice={editingDevice}
                  editValues={editValues}
                  onEditDevice={handleEditDevice}
                  onSaveEdit={handleSaveEdit}
                  onCancelEdit={handleCancelEdit}
                  onDeleteDevice={handleDeleteDevice}
                  onToggleStatus={handleToggleStatus}
                  onInputChange={handleInputChange}
                  formatDate={formatDate}
                />
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default RegisteredDevicesList;
